import React, { useState } from 'react';
import './ItemNavMobile.scss';
import { Fade } from "react-awesome-reveal";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";

interface ItemNavMobileProps {
  title: string;
  children: React.ReactNode;
  level?: number; // Para identificar niveles de anidación
}

const ItemNavMobile = ({ title, children, level = 1 }: ItemNavMobileProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className={`collapseItem ${isCollapsed ? 'collapsed' : ''}`}>
      <div
        className={`collapse-header flex justify-end items-center gap-2 text-base ${level > 1 ? 'pl-4' : ''}`}
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <h2 className={` text-xl font-semibold ${!isCollapsed ? "text-primary" : "text-white"}`}>{title}</h2>
      </div>
      {!isCollapsed && (
        <Fade>
          <div className={`collapse-content ${level > 1 ? '' : ''}`}>
            {children}
          </div>
        </Fade>
      )}
    </div>
  );
};

export default ItemNavMobile;